
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HeroCard',
  props: {
    showBackground: {
      type: Boolean,
      default: true
    },
    showGlow: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: 'md'
    },
    customClass: {
      type: String,
      default: ''
    },
    showBorder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true
    }, 100)
  }
})
